"use client";
import React from "react";
import {usePhrase} from "../../i18n";
import ProductRatingWidget from "../ProductRatingWidget/ProductRatingWidget";
import {formatCurrencySymbol, formatPriceStyle} from "../../utilities/price";
import {useFrontendConfiguratorContext} from "../ProductConfigurator/context";
import QuestionMarkCircleIcon from "@heroicons/react/24/outline/QuestionMarkCircleIcon";
import {sendGTMEvent} from "@next/third-parties/google";

const ProductInfo = ({product, storeCode, config, takeMeasuresLink = null, _t}) => {
    const t = usePhrase(_t);
    const {currentConfiguration} = useFrontendConfiguratorContext();

    const handleTakeMeasures = () => {

        sendGTMEvent({
            event: 'click_take_measure',
            product: product?.sku || '',
            storeView: storeCode
        });

        // open new tab with the link to the measures
        window.open(takeMeasuresLink, '_blank');
    }

    return <>
        <div className="mb-2 mt-4 lg:mt-0">
            <h1 className="text-xl font-normal">{product.shortDescriptionSanitized} <span
                className=" text-sm text-[#555]">({product.sku})</span></h1>
            <ProductRatingWidget storeCode={storeCode} count={product.reviews_count} average={product.reviews_average}
                                 _t={_t}/>
            <hr className={`spacer my-1`}/>
        </div>

            <div className={'flex flex-col'}>

                <div className={`flex items-center`}>
                    <span className={'text-sm'}>{t('From')} </span>
                    {product.promo &&
                        <div className={'!text-base  line-through text-[#555] mr-1 ml-2'}>
                            {formatPriceStyle(product.price_incl_tax, true)}
                            <span
                                className={`ml-1`}>{formatCurrencySymbol(config?.store?.default_display_currency_code)}</span>
                        </div>}
                    {product.discount_percentage && <div className={`my-2`}><span
                        className={`  bg-[#e7bb43] py-2 px-2 font-bold text-white rounded`}>{product.discount_percentage}% {t('OFF')}</span>
                    </div>}
                </div>

            </div>
            <div className={'flex justify-between items-end mb-2'}>
                <div className={`text-2xl font-bold `}>

                    {formatPriceStyle(product.final_price_incl_tax, true)}
                    <span className={`ml-1`}>
                        {formatCurrencySymbol(config?.store?.default_display_currency_code)}
                    </span>
                    <span>
                        {product.price_unit && <> / {product.price_unit}</>}
                    </span>

                    {(!config?.customs_info || !config?.customs_info?.enable_table) &&
                        <span className={'text-[#555] text-xs ml-1 font-normal'}>{t('tax included')}</span>}
                </div>
                <div>
                    {currentConfiguration?.variables && currentConfiguration.variables.find(variable => variable.code === 'MIN_FAT') &&
                        <p className={`text-sm text-right space-x-1`}>
                            <span>{t('Minimum billable')}:</span>
                            <b>{currentConfiguration.variables.find(variable => variable.code === 'MIN_FAT').value} {product.price_unit}</b>
                        </p>}
                </div>
            </div>




        <hr className={`spacer my-3`}/>

        {takeMeasuresLink &&
            <div className={`p-3 bg-[#e7bb43] text-white rounded font-bold my-2 flex items-center cursor-pointer`}
                 onClick={handleTakeMeasures}>
                <QuestionMarkCircleIcon className={`w-5 h-5 inline-block mr-2`}/>
                <span>{t(`Don't know how to take measurements? Click here!`)}</span>
            </div>}


    </>;

}

export default ProductInfo;